import { render, staticRenderFns } from "./OrderProductCard.vue?vue&type=template&id=fa651a38&"
import script from "./OrderProductCard.vue?vue&type=script&lang=js&"
export * from "./OrderProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports